var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"houses-item-board ma-0"},[_c('HousesItemBoardSearch',{staticClass:"mb-4"}),_c('HousesItemBoardFloors')],1)}
var staticRenderFns = []

export { render, staticRenderFns }